import { jsx as e } from "react/jsx-runtime";
import { Avatar as c, alpha as m } from "@mui/material";
import { Z as d, p as f, s as h, l as u } from "../../../index-DVHhaa_b.js";
import { stripHtmlAndDecode as I } from "../../../helpers/strings.js";
const D = ({ Category: t, Note: s, Title: a, Attachments: i }) => {
  const n = I(s, { allowLinks: !0, allowIframes: !0 }), { color: l, iconType: p } = d(t);
  let r = [];
  return i && i.forEach((o) => r.push(/* @__PURE__ */ e(f, { size: "small", fileName: o.FullName, fileId: o.FileID, extension: o.Ext, locationType: o.LocationType, url: o.Path, download: !0 }, o.FileID))), /* @__PURE__ */ e(
    h,
    {
      itemType: "lessonplan",
      title: a,
      description: n,
      avatar: /* @__PURE__ */ e(c, { variant: "rounded", sx: { height: 30, width: 30, bgcolor: m(l, 0.15), color: l }, children: /* @__PURE__ */ e(u, { iconType: p }) }),
      category: t,
      chips: r
    }
  );
};
export {
  D as LessonPlanItem
};
//# sourceMappingURL=lessonPlan.js.map
